import { KOGMediaQuery } from '@/main/services/utilsLayout';
import styled from 'styled-components';
import { css } from 'styled-components';

export const Container = styled.div`
  padding: 0 0 2rem;

  > h2 {
    font-weight: bold;
  }
`;

export const ContainerSection = styled.div`
  background-color: #ecf1f6;
  padding: 1rem;
  border-radius: 6px;
  margin: 0 0 2rem 0;
`;

export const AutoCompleteField = styled.div`
  overflow: hidden;
`;

export const RowSelect = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: flex-start;
  gap: 10px;
  overflow: hidden;

  @media (max-width: 426px) {
    grid-template-columns: 1fr;

    button {
      width: 100%;
      max-width: 100%;
      padding: 0.4rem 0 !important;
      margin: 0;
    }
  }
`;

export const ContainerPagination = styled.div`
  max-height: 390px;
  overflow-y: auto;
  overflow-x: hidden;
  margin: 0.6rem 0 2rem 0;
  padding: 1rem;
`;

export const AreaFilterGrid = styled.div`
  margin-left: auto;

  &&& {
    .MuiFormControl-root {
      margin: -04px 0 0 0;
    }
  }

  ${({ theme }) =>
    KOGMediaQuery({
      breakpoint: theme.breakpoints.mobile,
      styles: css`
        width: 100%;
        margin: 0;
      `
    })}
`;
